import React, { useContext, useEffect, useState } from "react";
import { TranslatorContext } from "../../../context/Translator";
import { Link } from "react-router-dom";
import { Row, Col, Form, Button } from "react-bootstrap";
import PageLayout from "../../../layouts/PageLayout";
import TrainingTableComponent from "../../../components/tables/TrainingTableComponent";
import axios from "axios";
import SchoolEnrollmentTable from "../../../components/tables/SchoolEnrollmentTable";

export default function SchoolEnrollments() {
  const { t } = useContext(TranslatorContext);

  const [trainings, setTrainings] = useState([]);
  const [allTrainings, setAllTrainings] = useState([]);

  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [schoolFilter, setSchoolFilter] = useState("");
  const [levelFilter, setLevelFilter] = useState("");

  const AuthToken = localStorage.getItem("AuthUser");

  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${AuthToken}`;

  useEffect(() => {
    fetchTrainings();
  }, []);

  const fetchTrainings = async () => {
    try {
      const res = await axios.get(
        process.env.REACT_APP_API_URL + "/school-enrollments"
      );

      const mappedData = res.data.enrollments.map((item) => ({
        id: item.id,

        going_image:
          process.env.REACT_APP_IMG_URL +  item.going_image,

        f_number: item.student?.family?.f_number,

        student_name: item.student?.name,

        dob: item.student?.dob,

        gender: item.student?.gender_id === 1 ? "Male" : "Female",

        guardian_name: item.student?.family?.beneficiary_name,

        cnic: item.student?.cnic,

        religion: item.student?.family?.faith?.name ?? "-",

        address: item.student?.family?.present_address,

        contact: item.student?.family?.mob,

        student_image:
          process.env.REACT_APP_IMG_URL + item.student_image,

        school_category: item.school?.authority,

        school_name: item.school?.name,

        level: item.school?.level,

        class_name: item.school_class?.name,

        enrollment_date: item.admission_date,

        fee: item.fee,

        cost: item.cost,

        total: Number(item.fee) + Number(item.cost),

        invoice:
          process.env.REACT_APP_IMG_URL  + item.fee_receipt,

      

        action: {
          edit: "edit",
          delete: "delete",
        },
      }));

      setTrainings(mappedData);
      setAllTrainings(mappedData);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    let filtered = [...allTrainings];

    // Search
    if (search) {
      filtered = filtered.filter(
        (item) =>
          item.student_name
            ?.toLowerCase()
            .includes(search.toLowerCase()) ||
          item.f_number
            ?.toLowerCase()
            .includes(search.toLowerCase())
      );
    }

    // Status
    if (statusFilter) {
      filtered = filtered.filter(
        (item) => item.status === statusFilter
      );
    }

    // School Filter
    if (schoolFilter) {
      filtered = filtered.filter(
        (item) => item.school_name === schoolFilter
      );
    }

    // Level Filter
    if (levelFilter) {
      filtered = filtered.filter(
        (item) => item.level === levelFilter
      );
    }

    setTrainings(filtered);
  }, [
    search,
    statusFilter,
    schoolFilter,
    levelFilter,
    allTrainings,
  ]);
  const schools = [
    ...new Set(
      allTrainings
        .map((item) => item.school_name)
        .filter(Boolean)
    ),
  ];

  const levels = [
    ...new Set(
      allTrainings
        .map((item) => item.level)
        .filter(Boolean)
    ),
  ];

  const statuses = [
    ...new Set(
      allTrainings
        .map((item) => item.status)
        .filter(Boolean)
    ),
  ];
  const resetFilters = () => {
  setSearch("");
  setStatusFilter("");
  setSchoolFilter("");
  setLevelFilter("");
};
  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">
                School Enrollments ({trainings.length} )
              </h3>
              <ul className="mc-breadcrumb-list">
                <li className="mc-breadcrumb-item">
                  <Link
                    to="#"
                    className="mc-breadcrumb-link"
                  >
                    {t("home")}
                  </Link>
                </li>

                <li className="mc-breadcrumb-item">
                  <Link
                    to="#"
                    className="mc-breadcrumb-link"
                  >
                    {t(
                      "School Enrollments"
                    )}
                  </Link>
                </li>

                <li className="mc-breadcrumb-item">
                  List
                </li>
              </ul>
            </div>
          </div>
        </Col>

        <Col xl={12}>
          <div className="mc-card">


            {/* Filters */}
            <Row className="mb-4">
              <Col md={3}>
                <Form.Control
                  type="text"
                  placeholder="Search Family / Student"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </Col>

              <Col md={2}>
                <Form.Select
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                >
                  <option value="">All Status</option>

                  {statuses.map((status, index) => (
                    <option key={index} value={status}>
                      {status}
                    </option>
                  ))}
                </Form.Select>
              </Col>

              <Col md={3}>
                <Form.Select
                  value={schoolFilter}
                  onChange={(e) => setSchoolFilter(e.target.value)}
                >
                  <option value="">All Schools</option>

                  {schools.map((school, index) => (
                    <option key={index} value={school}>
                      {school}
                    </option>
                  ))}
                </Form.Select>
              </Col>

              <Col md={3}>
                <Form.Select
                  value={levelFilter}
                  onChange={(e) => setLevelFilter(e.target.value)}
                >
                  <option value="">All Levels</option>

                  {levels.map((level, index) => (
                    <option key={index} value={level}>
                      {level}
                    </option>
                  ))}
                </Form.Select>
              </Col>

              <Col md={1}>
                <Button
                  variant="secondary"
                  className="w-100"
                  onClick={resetFilters}
                >
                  Reset
                </Button>
              </Col>
            </Row>

            <Row>
              <Col xl={12}>
                <SchoolEnrollmentTable
                  thead={[
                    "Sr. No",
                    "Picture of Student Going to School / Institute",
                    "FSF-ID",
                    "Student Name",
                    "Date of Birth",
                    "Gender (M/F)",
                    "Father/Guardian Name",
                    "CNIC",
                    "Religion",
                    "Present Address",
                    "Contact",
                    "Student Picture at Enrollment",
                    "School / Institute Category (Government/Private)",
                    "Name of School / Institute",
                    "Level (Primary/Elementary/Secondary/College/University)",
                    "Class / Course Enrollment",
                    "Enrollment Date",
                    "Legal Charges and Fee",
                    "Material Cost",
                    "Total Amount (PKR)",
                    "Invoice Image",
                  
                    // "Actions"
                  ]}
                  tbody={trainings}
                />
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </PageLayout>
  );
}